// @flow
export type SetBetaOptinAction = {
  type: "SET_BETA_OPTIN",
  payload: boolean
};

export const setBetaOptin = (isBeta: boolean): SetBetaOptinAction => ({
  type: "SET_BETA_OPTIN",
  payload: isBeta
});

export const setHasConnection = (hasConnection: boolean) => ({
  type: "SET_HAS_CONNECTION",
  payload: hasConnection
});

export const setHasCrossNavigation = (hasCrossNavigation: boolean) => ({
  type: "SET_HAS_CROSS_NAVIGATION",
  payload: hasCrossNavigation
});

export default setBetaOptin;
